import { createTheme } from "@material-ui/core";
import utilsDate from "../utils/Date";
import * as Yup from 'yup'
import { ErrorOption } from "react-hook-form";
import { OptionsObject, SnackbarKey, SnackbarMessage } from "notistack";
import { TFunction } from "i18next";

const getDefaultGridOptions = (t: Function) => {
    return {
        textLabels: {
                body: {
                    noMatch: t('noMatch'),
                    toolTip: "",
                },
                pagination: {
                    next: t("next"),
                    previous: t("previous"),
                    rowsPerPage: t("rowsPerPage") + ":",
                    displayRows: t("of"),
                }
            }
    };;
};

const defaultHeaderOptions = { 
    setCellHeaderProps: () => ({ align: "center" }),
    setCellProps: () => ({ align: "center" })
};

//TODO: Implementar cursor : hand quando tiver colecao.legnth > 0
const defaultGridTheme = createTheme({
    overrides: {
        MuiTableBody: {
            root: {
                cursor: ''
            }
        }
    }
})

function TimeShortDataFormat(value:any, tableMeta:any, updateValue:any)
{
    if(value != null)
    {
        return (<span>{utilsDate.TimeShortByCompleteDate(value)}</span>)
    }
    else
    {
        return <></>;
    }
}

function DataFormat(value:any, tableMeta:any, updateValue:any)
{
    if(value != null)
    {
        return (<span>{utilsDate.DateTime(value)}</span>)
    }
    else
    {
        return <></>;
    }
}


function CurrencyFormat(value:any, tableMeta:any, updateValue:any)
{
    if(value != null)
    {
        return (<span>{Number(value).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</span>)
    }
    else
    {
        return <></>;
    }
}

function MinutesToHHMMFormat(value:any, tableMeta:any, updateValue:any)
{
    if(value != null)
    {
        
        let hours = Math.floor(value / 60).toString().padStart(2, "0");
        let minutes = Math.floor(value % 60).toString().padStart(2, "0");

        return (<span>{hours + ":" + minutes}</span>)
    }
    else
    {
        return <></>;
    }
}

function MinutesToddHHMMFormat(value:any, tableMeta:any, updateValue:any)
{
    if(value != null)
    {
        let hours = Math.floor(value / 60);
        let minutes = Math.floor(value % 60);

        let formattedHours = hours.toString().padStart(2, "0");
        let formattedMinutes = minutes.toString().padStart(2, "0");

        let convertedTime = "";

        if (hours > 23) {
            let days = Math.floor(hours / 23);
            let leftoverHours = Math.floor(hours % 23).toString().padStart(2, "0");
            
            convertedTime = `${days}d ${leftoverHours}:${formattedMinutes}`;
        } else {
            convertedTime = `${formattedHours}:${formattedMinutes}`
        }
        
        return (<span>{convertedTime}</span>)
    }
    else
    {
        return <></>;
    }
}

//Permite a validacao do yup do tipo Numero mas que aceita valor vazio (e nao aceita espaços)
//Utilizacao: Yup.number().nullable(true).typeError(tval("mustBeNumber")).transform(YupValidateNullableNumber)
const YupValidateNullableNumber = (_:any, val:any)  => (val ? (val.indexOf(' ') >= 0 ? "ERR" : Number(val)) : null);    


//Validacao padrao de form - varias paginas usam uma copia deste metodo, elas podem ser substituidas para usar aqui e deixar o arquivo com menos codigo duplicado:
const YupValidation = async (data: any,
    schema: Yup.AnyObjectSchema,
    validationResource: TFunction,
    showSnackbar: boolean,
    enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey,
    clearErrors: ()=>void,
    setError: (name: any, error: ErrorOption) => void) => {
        var result = false;
        clearErrors();

        try {
            await schema.validate(data, {
                abortEarly: false,
            });

            result = true;
        }
        catch (err) {

            var errors: string[] = [];

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {

                    if (errors.filter(element => element.includes(error.message)).length === 0)
                        errors.push(error.message);

                    setError(error.path?.split('.')[0], { message: error.message });
                });
            }

            if (showSnackbar)
                errors.forEach(element => { 
                    if (element === validationResource("requiredField"))
                        enqueueSnackbar(validationResource("requiredFieldsValidation"), { variant: 'warning' });
                    else    
                        enqueueSnackbar(element, { variant: 'warning' });
                })

            result = false;
        }

        return result;
    }

//Regex replace para remover acentos de uma string (Fábio => Fabio)
const strSemAcentos = (val: string) =>
{
    return val
        .replace(/[áàâãä]/g, "a").replace(/[ÁÀÂÃÄ]/g, "A")
        .replace(/[éèêë]/g, "e").replace(/[ÉÈÊË]/g, "E")
        .replace(/[íìïî]/g, "i").replace(/[ÍÌÏÎ]/g, "I")
        .replace(/[ôóòöõ]/g, "o").replace(/[ÔÓÒÖÕ]/g, "O")
        .replace(/[ùúûü]/g, "u").replace(/[ÙÚÛÜ]/g, "U")
        .replace(/[ç]/g, "c").replace(/[Ç]/g, "C")
        .replace(/[Ñ]/g, "N").replace(/[ñ]/g, "n");
}

export default getDefaultGridOptions;
export { CurrencyFormat, defaultGridTheme, defaultHeaderOptions, TimeShortDataFormat, DataFormat, MinutesToHHMMFormat, MinutesToddHHMMFormat, YupValidateNullableNumber, YupValidation, strSemAcentos };

